import { render, staticRenderFns } from "./PublicLogistics.vue?vue&type=template&id=23689b91&scoped=true"
import script from "./PublicLogistics.vue?vue&type=script&lang=js"
export * from "./PublicLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23689b91",
  null
  
)

export default component.exports